import { Routes, Route } from "react-router-dom";
import type { AuthenticatedUser } from "../api/auth";
import { AIpad } from "../components/AIpad";
import type { LaunchpadTile } from "../components/Launchpad/Launchpad";

interface AnonymousTenantProps {
  currentUser?: AuthenticatedUser;
}

/**
 * Anonymous Tenant Component
 * 
 * Wird für nicht-authentifizierte Benutzer angezeigt.
 * Zeigt AIpad mit Login-Kachel im Feed.
 */
export function AnonymousTenant({ currentUser }: AnonymousTenantProps) {
  // Keine Tiles für anonyme Benutzer - Login wird als Feed-Card angezeigt
  const emptyTiles: LaunchpadTile[] = [];

  return (
    <AIpad tiles={emptyTiles}>
      <Routes>
        <Route path="*" element={<div />} />
      </Routes>
    </AIpad>
  );
}
